import { NodeSection } from "../props/node/constants";
export var AttachNodeVisitor = {
  NodeTree: function NodeTree(path, state) {
    var _state$opts = state.opts,
      componentId = _state$opts.componentId,
      nodeIds = _state$opts.nodeIds;
    if (typeof nodeIds === 'undefined') {
      this.executeChange(function () {
        state.nodeId = path.node.attachNode({
          componentId: componentId
        });
      });
    }
  },
  Node: {
    enterChild: function enterChild(path) {
      if (path.params.section !== NodeSection.CHILDREN) this.skip();
    },
    enter: function enter(path, state) {
      var parentId = state.opts.parentId;
      if (path.params.nodeId !== parentId) this.skip();
    }
  },
  AdaptiveDecorator: {
    enterChild: function enterChild(path, state) {
      if (!path.params.matchesInterval(state.opts)) this.skip();
    }
  },
  FieldsDecorator: {
    enterChild: function enterChild(path, state) {
      var fieldId = state.opts.fieldId;
      if (fieldId !== path.params.fieldId) this.skip();
    }
  },
  ListOfIdentifiers: function ListOfIdentifiers(path, state) {
    var beforeId = state.opts.beforeId;
    var nodeIds = state.opts.nodeIds || [state.nodeId];
    this.executeChange(function () {
      return path.node.attachNode({
        nodeIds: nodeIds,
        beforeId: beforeId
      });
    });
  }
};